import { render, staticRenderFns } from "./acceptAssignment.vue?vue&type=template&id=4033f406&scoped=true"
import script from "./acceptAssignment.vue?vue&type=script&lang=js"
export * from "./acceptAssignment.vue?vue&type=script&lang=js"
import style0 from "./acceptAssignment.vue?vue&type=style&index=0&id=4033f406&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4033f406",
  null
  
)

export default component.exports